import { IPFullReport } from "./full-report";
export default IPFullReport;
